import React, { useEffect, useState } from "react";
import Loading from "../Loading";
import Form from "react-bootstrap/Form";
import * as api from "../../api/api";
import { useLanguage } from "../../Components/Localization/LanguageContext";
import strings from "../../Components/Localization/strings";

import {
  BrowserRouter as Router,
  useParams,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import { Field, Formik } from "formik";
import {
  Alert,
  Box,
  Button,
  FormControlLabel,
  FormLabel,
  LinearProgress,
  Radio,
  Snackbar,
  TextareaAutosize,
} from "@mui/material";
import { RadioGroup, TextField } from "formik-mui";
import YesNoModal from "../Modal/YesNoModal";
import { cloneDeep } from "lodash";

export default function FormSection(props) {
  const { language } = useLanguage();
  const pageTitle = "FormSection";
  const emptyForm = {
    name: "",
    helpText: "",
    created: "",
    modified: "",
    isDisabled: false,
    isTemplate: false,
    isSystem: false,
    sectionsAligned: false,
    isBillable: false,
    counter: 0,
    activeFrom: "",
    activeTo: "",
    tenantId: 1,
    templateFormId: 1,
    templateInfo: "Template information",
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const navigate = useNavigate();
  const handleRankValue = (val) => setRank(val);

  const [formattedModifiedDate, setFormattedModifiedDate] = useState("");
  const { formsResponse, setFormsResponse, setInactiveForms } =
    useOutletContext();
  const params = useParams();
  let location = useLocation();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [rank, setRank] = useState(0);
  const [snackbar, setSnackbar] = useState({
    state: false,
    message: "",
    status: { success: "success", error: "error" },
  });
  const EmptyInitialValues = {
    columnIndex: 0,
    isExpanded: false,
    formId: params.id,
    helpText: "",
    name: "",
    rank: 1,
  };
  const [initialValues, setInitialValues] = useState({ ...EmptyInitialValues });
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbar({ state: false });
  };
  function updateSectionNames(services, sectionId, newName) {
    let newServices = cloneDeep(services);
    function updateSections(forms) {
      return forms.map((form) => ({
        ...form,
        sections: form.sections.map((section) =>
          section.sectionId === sectionId
            ? { ...section, name: newName }
            : section
        ),
      }));
    }

    newServices.forEach((service) => {
      service.callLineForms = updateSections(service.callLineForms);
      service.ddiForms = updateSections(service.ddiForms);
      service.offlineForms = updateSections(service.offlineForms);
      if (service.subServices) {
        updateSectionNames(service.subServices, sectionId, newName);
      }
    });

    return newServices;
  }
  function updateFormSections(services, formId, newSection) {
    let newServices = cloneDeep(services);
    function updateSections(forms) {
      return forms.map((form) =>
        form.formId == formId
          ? {
              ...form,
              sections: [
                ...form.sections,
                { ...newSection, sectionFields: [] },
              ],
            }
          : form
      );
    }

    newServices.forEach((service) => {
      service.callLineForms = updateSections(service.callLineForms);
      service.ddiForms = updateSections(service.ddiForms);
      service.offlineForms = updateSections(service.offlineForms);
      if (service.subServices) {
        updateSectionNames(service.subServices, formId, newSection);
      }
    });
    console.log("new services: ", newServices);
    return newServices;
  }
  function removeTargetSection(services, sectionId) {
    let newServices = cloneDeep(services);
    function updateSections(forms) {
      return forms.map((form) => ({
        ...form,
        sections: form.sections.filter(
          (section) => section.sectionId !== sectionId
        ),
      }));
    }

    newServices.forEach((service) => {
      service.callLineForms = updateSections(service.callLineForms);
      service.ddiForms = updateSections(service.ddiForms);
      service.offlineForms = updateSections(service.offlineForms);
      if (service.subServices) {
        updateSectionNames(service.subServices, sectionId);
      }
    });

    return newServices;
  }

  function handleDeleteModal() {
    api.deleteSectionById(params.sectionId).then((response) => {
      console.log(response);

      navigate("/formsandfields");
      let targetId = parseInt(params.sectionId);
      let newServices = removeTargetSection(formsResponse, targetId);
      setFormsResponse(newServices);
      setInactiveForms((prevState) =>
        prevState.map((form) => ({
          ...form,
          sections: form.sections.filter(
            (section) => section.sectionId !== targetId
          ),
        }))
      );
      // handleFetchServicesState();
      //window.location.reload();
    });
  }
  function handeInitializeSection() {
    console.log(location?.state);

    if (location?.state === null) {
      console.log("do nothing");
    } else if (location?.state.showDeleteModal === true) {
      setShowDeleteModal(true);
    } else if (location?.state.showDeleteModal === false) {
      setShowDeleteModal(false);
    }

    if (params.sectionId) {
      setLoading(true);
      console.log("section id is :", params.sectionId);
      api.getSectionById(params.sectionId).then((res) => {
        try {
          const result = res.data.object;
          console.log("result is :", result);
          const inputDate = new Date(result.modified);

          const options = {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
          };

          const formattedDate = new Intl.DateTimeFormat(
            "en-GB",
            options
          ).format(inputDate);

          setFormattedModifiedDate(formattedDate);
          setInitialValues(result);
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      });
    } else {
      //console.log(initialValues);
      setInitialValues(EmptyInitialValues);
    }
  }
  useEffect(() => {
    handeInitializeSection();
  }, [window.location, params]);
  return (
    <div className="main-content">
      {isLoading && <Loading />}{" "}
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validate={(values) => {
          const errors = {};
          if (!values.rank && !values.name) {
            errors.rank = "Required";
            errors.name = "Required";
          } else if (!/^[0-9]\d*$/.test(values.rank)) {
            errors.rank = "Invalid rank number";
          }
          return errors;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          if (params.sectionId) {
            //editing section
            api
              .updateSection(params.sectionId, values)
              .then((res) => {
                setSnackbar({
                  state: true,
                  message: res.data.message,
                  status: "success",
                });
                setSubmitting(false);
                console.log(res.data);
                // here we update the services state to reflect changes to section name directly after updating
                let targetId = parseInt(params.sectionId);
                let newServices = updateSectionNames(
                  formsResponse,
                  targetId,
                  values.name
                );
                setFormsResponse(newServices);
                setInactiveForms((prevState) =>
                  prevState.map((form) => ({
                    ...form,
                    sections: form.sections.map((section) =>
                      section.sectionId === targetId
                        ? { ...section, name: values.name }
                        : section
                    ),
                  }))
                );
              })
              .catch((err) => {
                setSnackbar({
                  state: true,
                  message: err.message,
                  status: "error",
                });
              });
          } else {
            // creating new section
            api
              .createSection(values)
              .then((res) => {
                setSnackbar({
                  state: true,
                  message: res.data.message,
                  status: "success",
                });
                setSubmitting(false);
                console.log(res.data);

                navigate(
                  "/formsandfields/" +
                    params.id +
                    "/section/" +
                    res.data.object.sectionId
                );
                let targetId = parseInt(values.formId);
                let newServices = updateFormSections(
                  formsResponse,
                  targetId,
                  res.data.object
                );
                setFormsResponse(newServices);
                setInactiveForms((prevState) =>
                  prevState.map((form) =>
                    form.formId == targetId
                      ? {
                          ...form,
                          sections: [
                            ...form.sections,
                            { ...res.data.object, sectionFields: [] },
                          ],
                        }
                      : form
                  )
                );
              })
              .catch((err) => {
                setSnackbar({
                  state: true,
                  message: err.message,
                  status: "error",
                });
              });
          }
        }}
      >
        {({ submitForm, isSubmitting, resetForm }) => (
          <Form
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              flexWrap: "wrap",
              maxWidth: "70%",
            }}
          >
            <Field
              component={TextField}
              name="name"
              type="Section Name"
              label={strings[pageTitle][language].sectionNameLabel}
            />
            <br />
            <Field component={TextField} name="rank" label="Rank" type="text" />
            <br />
            <FormLabel> {strings[pageTitle][language].visualLabel} </FormLabel>
            <Field component={RadioGroup} row label="split" name="isExpanded">
              <FormControlLabel
                value={true}
                control={<Radio disabled={isSubmitting} />}
                label={strings[pageTitle][language].expandedLabel}
                disabled={isSubmitting}
              />
              <FormControlLabel
                value={false}
                control={<Radio disabled={isSubmitting} />}
                label={strings[pageTitle][language].collapsedLabel}
                disabled={isSubmitting}
              />
            </Field>
            <FormLabel>
              {" "}
              {strings[pageTitle][language].helpTextLabel}{" "}
            </FormLabel>
            <Field component="textarea" name="helpText" label="Helptext" />
            <br />
            <FormLabel>
              {" "}
              {strings[pageTitle][language].positionLabel}{" "}
            </FormLabel>
            <Field component={RadioGroup} row label="split" name="columnIndex">
              <FormControlLabel
                value="0"
                control={<Radio disabled={isSubmitting} />}
                label="1"
                disabled={isSubmitting}
              />
              <FormControlLabel
                value="1"
                control={<Radio disabled={isSubmitting} />}
                label="2"
                disabled={isSubmitting}
              />
              <FormControlLabel
                value="2"
                control={<Radio disabled={isSubmitting} />}
                label="3"
                disabled={isSubmitting}
              />
            </Field>
            <p>
              <strong>{strings[pageTitle][language].lastModifiedLabel}:</strong>{" "}
              {formattedModifiedDate
                ? formattedModifiedDate
                : strings[pageTitle][language].never}
            </p>
            {isSubmitting && <LinearProgress />}
            <br />
            <Box style={{ display: "flex ", justifyContent: "end" }}>
              {params.sectionId ? (
                <button
                  className="button-round danger"
                  style={{ alignSelf: "flex-end", margin: "1em" }}
                  onClick={(e) => {
                    e.preventDefault();
                    setShowDeleteModal(true);
                  }}
                >
                  {strings[pageTitle][language].deleteButtonLabel}
                </button>
              ) : (
                ""
              )}
              <button
                className="button-round cancel"
                style={{ alignSelf: "flex-end", margin: "1em" }}
                onClick={(e) => {
                  e.preventDefault();
                  setShowCancelModal(true);
                }}
              >
                {strings[pageTitle][language].cancelButtonLabel}
              </button>
              <button
                className="button-round"
                style={{ alignSelf: "flex-end", margin: "1em" }}
                disabled={isSubmitting}
                onClick={submitForm}
              >
                {strings[pageTitle][language].saveButtonLabel}
              </button>
            </Box>
            <YesNoModal
              propShow={showDeleteModal}
              handleYes={handleDeleteModal}
              handleShowModal={() => {
                setShowDeleteModal(false);
                resetForm();
              }}
            >
              {strings[pageTitle][language].deleteConfirmationMessage}
            </YesNoModal>
            <YesNoModal
              propShow={showCancelModal}
              handleYes={handeInitializeSection}
              handleShowModal={() => {
                setShowCancelModal(false);
                resetForm();
              }}
            >
              {strings[pageTitle][language].resetConfirmationMessage}
            </YesNoModal>
          </Form>
        )}
      </Formik>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackbar.state}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.status}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
